<template>
  <div class="vx-row flex flex-wrap-reverse mx-0 w-full">
    <div class="vx-col w-full md:w-1/2 flex flex-wrap justify-between md:justify-start">
      <wizard-button
        :style="wizardProps.fillButtonStyle"
        class="w-full md:w-auto mr-0 md:mr-3 mb-3 md:mb-0 nav-prev"
        @click.native="$emit('cancel')">
        <i class="nav-icon feather icon-x"></i>
        <div class="nav-text">
          {{ $t('$General.Close') }}
        </div>
      </wizard-button>

      <wizard-button
        v-if="wizardProps.activeTabIndex > 0"
        :style="wizardProps.fillButtonStyle"
        class="w-full md:w-auto mr-0 md:mr-3 mb-3 md:mb-0 nav-prev"
        @click.native="prevStep">
        <i class="nav-icon feather icon-arrow-left"></i>
        <div class="nav-text">
          {{ $t('$General.Back') }}
        </div>
      </wizard-button>

      <wizard-button
        :style="wizardProps.fillButtonStyle"
        class="w-full md:w-auto nav-next"
        @click.native="nextStep">
        <i
          class="nav-icon feather icon-arrow-right"
          :class="wizardProps.isLastStep ? 'icon-check' : 'icon-arrow-right'"
        ></i>
        <div class="nav-text">
          {{ $t(`$General.${wizardProps.isLastStep ? 'Done' : 'Continue'}`) }}
        </div>
      </wizard-button>
    </div>
  </div>
</template>

<script>
import { WizardButton } from 'vue-form-wizard';

/**
 * Reviews settings create or edit wizard buttons
 *
 * @module views/modules/reviews/ReviewsSettingsCreateOrEditWizardButtons
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-prop {Object} wizardProps - wizard props
 */
export default {
  name: 'WaitingListConfigurationWizardButtons',
  components: {
    WizardButton,
  },
  props: {
    wizardProps: {
      type: Object,
      required: true,
    },
    configTemplatesTabIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    nextStep() {
      if (this.wizardProps.activeTabIndex === 1 && this.configTemplatesTabIndex < 6) {
        this.$emit('next-config-temp-step');
      } else {
        this.wizardProps.nextTab();
      }
    },
    prevStep() {
      if (this.wizardProps.activeTabIndex === 1 && this.configTemplatesTabIndex > 0) {
        this.$emit('prev-config-temp-step');
      } else {
        this.wizardProps.prevTab();
      }
    },
  },
};
</script>
